import React, { Fragment } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';

import { fetchPrzelewy } from '../../../../Redux/Actions.js'; 

const ImportTransakcjiSend = props => {

    const dispatch = useDispatch();

    const {pelneDane, setFileName, setPelneDane, setCzyDubel, setWczytane, setCzyWplataNaKontoGlowne, wybranaWspolnota} = props;

    async function sendHandle() {
        const promises = pelneDane.map(async (item, index) => {
            try {
              const response = await axios.post('/api/przelewy/dodaj', item);
              console.log(`Response for item ${index}:`, response.data);
              
            } catch (error) {
              console.error(`Error for item ${index}:`, error);
            }
        })

        await Promise.all(promises)
        setFileName("");
        setPelneDane([]);
        document.getElementById("file-input").value = "";
        setCzyDubel(false);
        setWczytane([]);
        dispatch(fetchPrzelewy(wybranaWspolnota?.id)); 
        setCzyWplataNaKontoGlowne(false);
    }

    const clearHandle = () => {
        setFileName("");
        setPelneDane([]);
        document.getElementById("file-input").value = "";
        setCzyDubel(false);
        setWczytane([]);
        setCzyWplataNaKontoGlowne(false);
    }

    return (
        <div className='send'>
            { pelneDane && pelneDane.length > 0 ? (
                <Fragment>
                    <button 
                        onClick={sendHandle}
                    >
                        Wyślij plik 
                    </button>
                    <button
                        onClick={clearHandle}
                    >
                        Wyczyść
                    </button>
                </Fragment>
            ) : ""
                
            }
        </div>
    )
}

export default ImportTransakcjiSend;